import { render, staticRenderFns } from "./saleadd.vue?vue&type=template&id=0b781441&scoped=true&"
import script from "./saleadd.vue?vue&type=script&lang=js&"
export * from "./saleadd.vue?vue&type=script&lang=js&"
import style0 from "./saleadd.vue?vue&type=style&index=0&id=0b781441&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b781441",
  null
  
)

export default component.exports